export default __webpack_public_path__ + "static/media/confirmed.247e6b86.svg";